import React from "react";
import HomeSection from "../Components/Home";

const HomePage = ({ history }) => {
  return <HomeSection onRequest={() => history.push("/request-form")} />;
};

export default HomePage;
